// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --first-color: #155263;
    --second-color: #ff6f3c;
    --third-color: #ff9a3c;
    --fourth-color: #ffc93c;
}

.App {
    text-align: center;
    font-family: Roboto, "Helvetica Neue", sans-serif;
    font-size: 11pt;
    /* background-color: #F0F0F0; */
}

/* -----------------------------------------------------------------------------
 * PAGE
 * -------------------------------------------------------------------------- */

.page {
    height: 100vh;
}

/* -----------------------------------------------------------------------------
 * MENU CONTAINER & MENU
 * -------------------------------------------------------------------------- */

.sidebar {
    height: 100vh;
    vertical-align: top;
    /* overflow: scroll; */
    background-color: #f0f0f0;
}

.menu-container {
    /* height: 100vh; */
    vertical-align: top;
    overflow: scroll;
    background-color: #f0f0f0;
}

.menu {
    /* background-color: #F0F0F0; */
    margin: 0px;
    padding-left: 5px;
    padding-right: 5px;
    padding-bottom: 3px;
    padding-top: 3px;
    gap: 0px;
    text-align: left;
}
.menu table {
    margin-top: 5px;
}

.menu table tr {
    margin-top: 0px;
}

.menu table td {
    margin: 0px;
}

.menu table th {
    margin: 0px;
}

input {
    text-align: right;
    width: 80px;
    font-family: Roboto, "Helvetica Neue", sans-serif; /* monospace digits ; see alse <Text style={{fontVariant: ['tabular-nums']}}> */
}

button.cross {
    background-color: transparent;
    border-width: 0em;
    color: lightgrey;
}

button.cross:hover {
    color: grey;
}

button.cross:active {
    color: darkred;
}

.listingTable2 {
    td:nth-child(1) {
        text-align: left;
    }
    td:nth-child(2) {
        text-align: right;
    }
    td:nth-child(3) {
        text-align: right;
    }
}

table {
    padding: 0px;
    margin: 0px;
    border-collapse: collapse;
}

table th {
    font-weight: 300;
    padding-right: 3px;
    margin: 0px;
}

table td {
    margin: 0px;
    padding-left: 0px;
    padding-top: 2px;
    padding-bottom: 2px;
    padding-right: 2px;
}

div.card {
    background-color: #fefefe; /*var(--fourth-color);*/
    /* border-radius: 5px; */
    /* box-shadow: 0px 1px 2px #AEAEAE; */
    margin: 5px;
    padding-left: 5px;
    padding-right: 5px;
    padding-bottom: 5px;
    padding-top: 0px;
    gap: 0px;
    text-align: left;
}

p.cardTitle {
    font-weight: 300;
    text-align: left;
    padding: 0px;
    margin-top: 2px;
}

.popup {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: #fff;
    padding: 20px;
    border: 1px solid #ccc;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    z-index: 1000;
}

.popupWrapper {
    display: flex;
    align-items: flex-end;
}

.pig {
    margin-top: 10px;
    display: flex;
    flex-direction: row;
    align-items: end;
}

/* todo solve either inheritance or composed class?*/
.tab-active {
    font-size: small;
    /*padding: 10px 60px;*/
    cursor: pointer;
    opacity: 0.6;
    background: white;
    border: 0;
    outline: 0;
    border-bottom: 2px solid grey;
    opacity: 1;
}

.tab-inactive {
    font-size: small;
    /*padding: 10px 60px;*/
    cursor: pointer;
    opacity: 0.6;
    background: white;
    border: 0;
    outline: 0;
}

/* ------------------------------- */

a {
    color: black;
    text-decoration: none;
}

a:hover {
    color: darkorchid;
    cursor: grab;
}

h1 {
    color: var(--first-color);
    font-size: x-large;
    /* background-color: lightskyblue; */
}

h2 {
    color: var(--first-color);
    font-size: large;
    padding-top: 20px;
    padding-bottom: 0px;
    margin-bottom: 0px;
}

p {
    text-align: justify;
}

/* ------------------------------- */

.data-table td,
.data-table th {
    padding-left: 5px;
    padding-right: 5px;
    border-left: solid 1px lightgray;
    border-right: solid 1px lightgray;
}

.data-table th {
    font-size: small;
    background-color: #f0f0f0;
}

.data-table {
    border-collapse: collapse;
    margin-top: 5px;
    border: none;
    /* border-bottom: solid 1px lightgray;
    border-top: solid 1px lightgray; */
    td:nth-child(1) {
        text-align: center;
        border-left: none;
    }
    td:nth-child(2) {
        text-align: center;
    }
    td:nth-child(3) {
        text-align: left;
    }
    td:nth-child(5) {
        text-align: right;
    }
    td:nth-child(6) {
        text-align: right;
    }
    td:last-child {
        border-right: none;
    }

    th:nth-child(1) {
        text-align: center;
        border-left: none;
    }
    th:nth-child(2) {
        text-align: center;
    }
    th:nth-child(3) {
        text-align: left;
    }
    th:nth-child(5) {
        text-align: right;
    }
    th:nth-child(6) {
        text-align: right;
    }
    th:last-child {
        border-right: none;
    }

    tr:nth-child(even) {
        background-color: #f9f9e1;
    }
    width: 100%;
}

.example {
    /* background-color: #eeffde; */
    border: solid 1px lightgray;
    border-radius: 4px;
    padding: 5px;
    padding-top: 0px;
    margin: 0px;
    margin-top: 15px;
}

.ex-label {
    background-color: lightyellow;
    margin-right: 5px;
}

.example > p {
    margin-top: 3px;
    /* padding-top: 2px; */
}

.example > p:last-child {
    margin-bottom: 3px;
}

.c1 {
    color: #2aafe4;
}

.c2 {
    color: #49beb7;
}

.c3 {
    color: #daa949;
}

.c4 {
    color: #ee5959;
}

.c5 {
    color: violet;
}

#data-types-shooting {
    margin-top: 5px;
    td:nth-child(1) {
        text-align: left;
    }
    td:nth-child(2) {
        text-align: right;
    }
    td:nth-child(3) {
        text-align: left;
    }
}

p > ul {
    margin-top: 5px;
}

p > ul > li {
    margin-top: 5px;
}

#table-binning-trees {
    td:nth-child(1) {
        text-align: center;
    }
    td:nth-child(2) {
        text-align: left;
    }
    td:nth-child(3) {
        text-align: right;
    }
    td:nth-child(4) {
        text-align: right;
    }

    th:nth-child(1) {
        text-align: center;
    }
    th:nth-child(2) {
        text-align: left;
    }
    th:nth-child(3) {
        text-align: right;
    }
    th:nth-child(4) {
        text-align: right;
    }
}

#table-comparison-histogram-bar-chart {
    td:nth-child(1) {
        text-align: left;
        width: 50%;
    }
    td:nth-child(2) {
        text-align: left;
        width: 50%;
    }

    th:nth-child(1) {
        text-align: left;
        width: 50%;
    }
    th:nth-child(2) {
        text-align: left;
        width: 50%;
    }
}

#version-footer {
    bottom: 0;
}

.navigation-icon {
    /* vertical-align: bottom; */
    border: none;
    background-color: transparent;
    cursor: pointer;
    color: #daa949;
}

.navigation-icon:hover {
    color: coral;
}

.navigation-icon:active {
    color: darkred;
}

.small-text {
    margin-top: 3px;
    font-size: 9pt;
    margin-bottom: 3px;
}

.author-card {
    display: flex;
    flex-direction: row;
    align-content: flex-start;
    padding-top: 20px;
    gap: 5px;
}

.author-heading {
    font-size: large;
    font-weight: 300;
    color: #333333;
    text-align: left;
    margin: 0px;
    padding: 0px;
}

.author-titles {
    font-size: smaller;
    color: grey;
    padding: 0;
    padding-bottom: 5px;
    margin: 0;
}

.author-part-left {
    display: flex;
    flex-direction: column;
    align-content: flex-start;
    flex-basis: 180px;
    flex-grow: 2;
    min-width: 80px;
    max-width: 200px;
    padding-top: 0px;
    margin-top: 0px;
}

.author-part-right {
    flex-basis: 400px;
    flex-grow: 4;
    min-width: 200px;
    padding-top: 2px;
    padding-left: 5px;
    margin-top: 0px;
}

.external-link {
    color: #007bff;
    text-decoration: none;
}

.external-link:hover {
    text-decoration: underline;
}

.no-bullets {
    list-style-type: none;
}

/* - SIMPLE VALUE TABLE ------------------------------ */

.simple-table td,
.simple-table th {
    padding-left: 5px;
    padding-right: 5px;
    border-left: solid 1px lightgray;
    border-right: solid 1px lightgray;
    border-top: solid 1px lightgray;
    border-bottom: solid 1px lightgray;
    text-align: center; /* Optional: Centers the text inside cells */
}

.simple-table th {
    font-size: small;
    background-color: #f0f0f0;
}

.simple-table {
    border-collapse: collapse;
    table-layout: fixed; /* Ensures the table layout is fixed */
    margin-top: 5px;
    margin-bottom: 10px;
    width: 100%;
    border-left: solid 1px lightgray;
    border-right: solid 1px lightgray;
}

.element-1 {
    color: #0f9b8e;
}
.element-2 {
    color: #138f8c;
}
.element-3 {
    color: #17838a;
}
.element-4 {
    color: #1b7788;
}
.element-5 {
    color: #1f6b86;
}
.element-6 {
    color: #236084;
}
.element-7 {
    color: #275582;
}
.element-8 {
    color: #2b4a80;
}
.element-9 {
    color: #2f3f7e;
}
.element-10 {
    color: #33347c;
}

.highlight-median {
    background-color: #e0ffd0;
}

.highlight-quantile {
    background-color: #fae5a9;
}

#table-interest-rates {
    table-layout: auto;
    td:nth-child(1) {
        text-align: center;
    }
    td:nth-child(2) {
        text-align: left;
    }
    width: auto;
}

#table-kinds-of-mean {
    table-layout: auto;
    td:nth-child(1) {
        text-align: center;
    }
    td:nth-child(2) {
        text-align: center;
    }
    td:nth-child(3) {
        text-align: left;
    }
    td:nth-child(4) {
        text-align: left;
        max-width: 150px;
    }
    td:nth-child(5) {
        text-align: center;
    }
}

#variance-with-popmean {
    table-layout: auto;
    td:nth-child(1) {
        text-align: center;
    }
    td:nth-child(2) {
        text-align: center;
    }
    td:nth-child(3) {
        text-align: center;
    }
    td:nth-child(4) {
        text-align: center;
    }
    td:nth-child(5) {
        text-align: center;
    }
}

/* Sets A - tables */
/* ------------------------------- */

.data-table-powerset th {
    background-color: grey;
    color: white;
}

.data-table-powerset {
    td:nth-child(1) {
        text-align: center;
        width: 40px;
        border-left: none;
    }
    td:nth-child(2) {
        text-align: center;
        width: 40px;
    }
    td:nth-child(3) {
        text-align: center;
        width: 40px;
    }
    td:nth-child(4) {
        text-align: left;
    }
    td:last-child {
        border-right: none;
    }

    th:nth-child(1) {
        text-align: center;
        width: 40px;
        border-left: none;
    }
    th:nth-child(2) {
        text-align: center;
        width: 40px;
    }
    th:nth-child(3) {
        text-align: center;
        width: 40px;
    }
    th:nth-child(4) {
        text-align: left;
    }
    th:last-child {
        border-right: none;
    }
}

.simple-table-ops {
    table-layout: auto;
    td:nth-child(1) {
        text-align: left;
        width: 52px;
    }
    td:nth-child(2) {
        text-align: center;
    }
    td:nth-child(3) {
        text-align: left;
    }
    td:nth-child(4) {
        text-align: center;
    }
    td:nth-child(5) {
        text-align: right;
        border-right: none;
    }
    td:nth-child(6) {
        text-align: left;
        border-left: none;
    }
    td:last-child {
        border-right: none;
    }

    th:nth-child(5) {
        text-align: left;
        border-right: none;
    }
    th:nth-child(6) {
        text-align: left;
        border-left: none;
    }
}

ul.abc-list {
    list-style-type: none;
    padding: 10px;
    margin: 0px;
    padding-top: 0px;
}

ul.abc-list li {
    padding-top: 10px;
    margin-left: 20px;
    text-indent: -20px;
}

ul.abc-list li::before {
    content: attr(data-marker);
    font-weight: normal;
    margin-right: 10px;
    /* display: inline-block; */
}

.simple-table-basic {
    table-layout: auto;
    td:nth-child(1) {
        text-align: left;
    }
    td:nth-child(2) {
        text-align: left;
    }

    th:nth-child(1) {
        text-align: left;
    }
    th:nth-child(2) {
        text-align: left;
    }

    td:last-child {
        border-right: none;
    }
    th:last-child {
        border-right: none;
    }

    td:first-child {
        border-left: none;
    }
    th:first-child {
        border-left: none;
    }
}

.table-elementary-events {
    td:nth-child(1) {
        width: 40%;
    }
    th:nth-child(1) {
        width: 40%;
    }
}

.event-space-table-die {
    th:nth-child(1) {
        text-align: left;
    }
    th:nth-child(2) {
        text-align: center;
    }

    th:nth-child(3) {
        text-align: left;
    }
    th:nth-child(4) {
        text-align: center;
    }

    th:nth-child(5) {
        text-align: left;
    }
    th:nth-child(6) {
        text-align: center;
    }

    th:nth-child(7) {
        text-align: left;
    }
    th:nth-child(8) {
        text-align: center;
    }

    td:nth-child(1) {
        text-align: left;
    }
    td:nth-child(2) {
        text-align: center;
    }

    td:nth-child(3) {
        text-align: left;
    }
    td:nth-child(4) {
        text-align: center;
    }

    td:nth-child(5) {
        text-align: left;
    }
    td:nth-child(6) {
        text-align: center;
    }

    td:nth-child(7) {
        text-align: left;
    }
    td:nth-child(8) {
        text-align: center;
    }
}

.table-probability-overview tr:nth-child(2) td {
    border-bottom: none;
}
.table-probability-overview tr:nth-child(3) td {
    border-top: none;
}

.table-probability-overview th {
    text-align: left;
}

.table-probability-overview td {
    text-align: left;
}

/* --- TOC ---------------------------- */

.page > span {
    height: 100%;
    width: 100%;
}

.chapter-container {
    display: flex;
    flex-direction: row;
    /*align-items: center; */
    /* width: 100%; */
    box-sizing: border-box;
    position: relative;
    width: 100%;
    height: 100%;
}

.toc {
    position: absolute;
    top: 0;
    right: 0;
    max-height: 100vh;
    overflow-y: auto;
    padding: 1rem;
    background-color: #f0f0f0;
    width: 150px;
    text-align: left;
}

.toc ul {
    list-style: none;
    padding: 0;
}

.toc li {
    margin: 0.5rem 0;
    cursor: pointer;
    color: #404040;
}

.toc li:hover {
    /* text-decoration: underline; */
    color: darkorchid;
    /* cursor: grab; */
}

div.centered-content {
    width: 710px;
    max-width: 710px;
    min-width: 710px;
    height: 100%;
    flex-grow: 0;
    flex-shrink: 0;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    padding: 0;
    margin: 0;
    overflow: scroll;
}

.table-dictionary {
    td:nth-child(1) {
        text-align: left;
        width: 200px;
    }
    td:nth-child(2) {
        text-align: left;
        width: 200px;
    }
    td:nth-child(3) {
        text-align: left;
        width: 200px;
    }

    th:nth-child(1) {
        text-align: left;
    }
    th:nth-child(2) {
        text-align: left;
    }
    th:nth-child(3) {
        text-align: left;
    }
}

.simple-table-ed {
    table-layout: auto;
    text-align: center;
    td:nth-child(1) {
        text-align: left;
    }
    th:nth-child(1) {
        text-align: left;
    }
}

/*  */
.histogram-table {
    border-collapse: collapse;
    margin-top: 5px;
    border: none;
    width: 100%;
    /* border-bottom: solid 1px lightgray;
    border-top: solid 1px lightgray; */
}
.histogram-table td:nth-child(1) {
    text-align: center;
    border-left: none;
}

.histogram-table td:nth-child(2),
.histogram-table td:nth-child(3),
.histogram-table td:nth-child(4),
.histogram-table td:nth-child(5),
.histogram-table td:nth-child(6) {
    text-align: center;
}

.histogram-table td:last-child {
    border-right: none;
}

.histogram-table th:nth-child(1) {
    text-align: center;
    border-left: none;
}
.histogram-table th:nth-child(2),
.histogram-table th:nth-child(3),
.histogram-table th:nth-child(4),
.histogram-table th:nth-child(5),
.histogram-table th:nth-child(6) {
    text-align: center;
}
.histogram-table th:last-child {
    border-right: none;
}

.histogram-table tr:nth-child(even) {
    background-color: #f9f9e1;
}

.histogram-table tbody tr:last-of-type {
    border-top: double 3px gainsboro;
    border-bottom: solid 1px gainsboro;
}

.histogram-table-ex tbody td:nth-child(4) {
    text-align: right;
    padding-right: 22px;
}

.histogram-table-ex tbody tr:last-of-type {
    border-top: none;
    border-bottom: solid 1px gainsboro;
}

/* ol {
    list-style-position: inside;
    padding-left: 5px;
} */

.alpha-list {
    list-style: none;
    counter-reset: list-counter;
    margin-left: 0px;
    padding-left: 20px;
}

.alpha-list li {
    counter-increment: list-counter;
    /* display: flex; /* Ensures proper indentation */
    align-items: flex-start;
}

.alpha-list li::before {
    content: counter(list-counter, lower-alpha) ") ";
    min-width: 2em; /* Ensures the label (a), b), etc.) has space */
    flex-shrink: 0; /* Prevents it from shrinking */
}

.main-ex-list {
    counter-reset: main-counter;
    list-style: none;
}

.main-ex-list > li {
    counter-increment: main-counter;
    list-style-type: none;
    margin-bottom: 8px;
}

.main-ex-list > li::before {
    content: counter(main-counter) ". ";
    font-weight: normal;
}

/* // probablitiy */

.prob-theory {
    display: flex;
    flex-direction: row;
    margin-bottom: 10px;
}

.prob-example {
    display: flex;
    flex-direction: row;
    background-color: #eeeeee;
    margin-bottom: 10px;
}

.prob-example div {
    padding-left: 10px;
    padding-right: 10px;
}

.prob-theory div {
    padding-left: 10px;
    padding-right: 10px;
}

.prob-example > div:not(:last-child) {
    border-right: 1px solid lightgrey; /* Add light grey divider */
}

.prob-theory > div:not(:last-child) {
    border-right: 1px solid lightgrey; /* Add light grey divider */
}

.table-interval-estimation {
    table-layout: auto;
    td:nth-child(2) {
        text-align: left;
    }
    td:nth-child(3) {
        text-align: left;
    }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,iDAAiD;IACjD,eAAe;IACf,+BAA+B;AACnC;;AAEA;;+EAE+E;;AAE/E;IACI,aAAa;AACjB;;AAEA;;+EAE+E;;AAE/E;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,+BAA+B;IAC/B,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,QAAQ;IACR,gBAAgB;AACpB;AACA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,iDAAiD,EAAE,+EAA+E;AACtI;;AAEA;IACI,6BAA6B;IAC7B,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;QACI,gBAAgB;IACpB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB,EAAE,uBAAuB;IAClD,wBAAwB;IACxB,qCAAqC;IACrC,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,wCAAwC;IACxC,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA,oDAAoD;AACpD;IACI,gBAAgB;IAChB,sBAAsB;IACtB,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,SAAS;IACT,UAAU;IACV,6BAA6B;IAC7B,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,SAAS;IACT,UAAU;AACd;;AAEA,oCAAoC;;AAEpC;IACI,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,oCAAoC;;AAEpC;;IAEI,iBAAiB;IACjB,kBAAkB;IAClB,gCAAgC;IAChC,iCAAiC;AACrC;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,YAAY;IACZ;sCACkC;IAClC;QACI,kBAAkB;QAClB,iBAAiB;IACrB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;QAClB,iBAAiB;IACrB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,kBAAkB;IACtB;;IAEA;QACI,yBAAyB;IAC7B;IACA,WAAW;AACf;;AAEA;IACI,+BAA+B;IAC/B,2BAA2B;IAC3B,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf;QACI,gBAAgB;IACpB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI;QACI,kBAAkB;IACtB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;IACtB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,UAAU;IACd;IACA;QACI,gBAAgB;QAChB,UAAU;IACd;;IAEA;QACI,gBAAgB;QAChB,UAAU;IACd;IACA;QACI,gBAAgB;QAChB,UAAU;IACd;AACJ;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,4BAA4B;IAC5B,YAAY;IACZ,6BAA6B;IAC7B,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,iBAAiB;IACjB,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qBAAqB;AACzB;;AAEA,wDAAwD;;AAExD;;IAEI,iBAAiB;IACjB,kBAAkB;IAClB,gCAAgC;IAChC,iCAAiC;IACjC,+BAA+B;IAC/B,kCAAkC;IAClC,kBAAkB,EAAE,4CAA4C;AACpE;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,mBAAmB,EAAE,sCAAsC;IAC3D,eAAe;IACf,mBAAmB;IACnB,WAAW;IACX,gCAAgC;IAChC,iCAAiC;AACrC;;AAEA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB;QACI,kBAAkB;IACtB;IACA;QACI,gBAAgB;IACpB;IACA,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB;QACI,kBAAkB;IACtB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,gBAAgB;QAChB,gBAAgB;IACpB;IACA;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,kBAAkB;IAClB;QACI,kBAAkB;IACtB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,kBAAkB;IACtB;AACJ;;AAEA,oBAAoB;AACpB,oCAAoC;;AAEpC;IACI,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI;QACI,kBAAkB;QAClB,WAAW;QACX,iBAAiB;IACrB;IACA;QACI,kBAAkB;QAClB,WAAW;IACf;IACA;QACI,kBAAkB;QAClB,WAAW;IACf;IACA;QACI,gBAAgB;IACpB;IACA;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,iBAAiB;IACrB;IACA;QACI,kBAAkB;QAClB,WAAW;IACf;IACA;QACI,kBAAkB;QAClB,WAAW;IACf;IACA;QACI,gBAAgB;IACpB;IACA;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,kBAAkB;IAClB;QACI,gBAAgB;QAChB,WAAW;IACf;IACA;QACI,kBAAkB;IACtB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,iBAAiB;QACjB,kBAAkB;IACtB;IACA;QACI,gBAAgB;QAChB,iBAAiB;IACrB;IACA;QACI,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;IACtB;IACA;QACI,gBAAgB;QAChB,iBAAiB;IACrB;AACJ;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,mBAAmB;IACnB,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB;QACI,gBAAgB;IACpB;IACA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;IACA;QACI,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;IACtB;IACA;QACI,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;IACrB;IACA;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;IACA;QACI,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;IACpB;IACA;QACI,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;IACpB;IACA;QACI,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;IACpB;IACA;QACI,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;IACpB;IACA;QACI,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;IACpB;IACA;QACI,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;IACpB;IACA;QACI,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;IACpB;IACA;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,mBAAmB;AACvB;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,yCAAyC;;AAEzC;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,wBAAwB;IACxB,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,gCAAgC;IAChC,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,SAAS;IACT,2BAA2B;IAC3B,UAAU;IACV,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI;QACI,gBAAgB;QAChB,YAAY;IAChB;IACA;QACI,gBAAgB;QAChB,YAAY;IAChB;IACA;QACI,gBAAgB;QAChB,YAAY;IAChB;;IAEA;QACI,gBAAgB;IACpB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB;QACI,gBAAgB;IACpB;IACA;QACI,gBAAgB;IACpB;AACJ;;AAEA,KAAK;AACL;IACI,yBAAyB;IACzB,eAAe;IACf,YAAY;IACZ,WAAW;IACX;sCACkC;AACtC;AACA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;;;;;IAKI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;AACA;;;;;IAKI,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gCAAgC;IAChC,kCAAkC;AACtC;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,kCAAkC;AACtC;;AAEA;;;GAGG;;AAEH;IACI,gBAAgB;IAChB,2BAA2B;IAC3B,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,+BAA+B;IAC/B,iDAAiD;IACjD,uBAAuB;AAC3B;;AAEA;IACI,gDAAgD;IAChD,cAAc,EAAE,+CAA+C;IAC/D,cAAc,EAAE,+BAA+B;AACnD;;AAEA;IACI,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,+BAA+B;IAC/B,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,mCAAmC;IACnC,mBAAmB;AACvB;;AAEA,mBAAmB;;AAEnB;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,iCAAiC,EAAE,2BAA2B;AAClE;;AAEA;IACI,iCAAiC,EAAE,2BAA2B;AAClE;;AAEA;IACI,kBAAkB;IAClB;QACI,gBAAgB;IACpB;IACA;QACI,gBAAgB;IACpB;AACJ","sourcesContent":[":root {\n    --first-color: #155263;\n    --second-color: #ff6f3c;\n    --third-color: #ff9a3c;\n    --fourth-color: #ffc93c;\n}\n\n.App {\n    text-align: center;\n    font-family: Roboto, \"Helvetica Neue\", sans-serif;\n    font-size: 11pt;\n    /* background-color: #F0F0F0; */\n}\n\n/* -----------------------------------------------------------------------------\n * PAGE\n * -------------------------------------------------------------------------- */\n\n.page {\n    height: 100vh;\n}\n\n/* -----------------------------------------------------------------------------\n * MENU CONTAINER & MENU\n * -------------------------------------------------------------------------- */\n\n.sidebar {\n    height: 100vh;\n    vertical-align: top;\n    /* overflow: scroll; */\n    background-color: #f0f0f0;\n}\n\n.menu-container {\n    /* height: 100vh; */\n    vertical-align: top;\n    overflow: scroll;\n    background-color: #f0f0f0;\n}\n\n.menu {\n    /* background-color: #F0F0F0; */\n    margin: 0px;\n    padding-left: 5px;\n    padding-right: 5px;\n    padding-bottom: 3px;\n    padding-top: 3px;\n    gap: 0px;\n    text-align: left;\n}\n.menu table {\n    margin-top: 5px;\n}\n\n.menu table tr {\n    margin-top: 0px;\n}\n\n.menu table td {\n    margin: 0px;\n}\n\n.menu table th {\n    margin: 0px;\n}\n\ninput {\n    text-align: right;\n    width: 80px;\n    font-family: Roboto, \"Helvetica Neue\", sans-serif; /* monospace digits ; see alse <Text style={{fontVariant: ['tabular-nums']}}> */\n}\n\nbutton.cross {\n    background-color: transparent;\n    border-width: 0em;\n    color: lightgrey;\n}\n\nbutton.cross:hover {\n    color: grey;\n}\n\nbutton.cross:active {\n    color: darkred;\n}\n\n.listingTable2 {\n    td:nth-child(1) {\n        text-align: left;\n    }\n    td:nth-child(2) {\n        text-align: right;\n    }\n    td:nth-child(3) {\n        text-align: right;\n    }\n}\n\ntable {\n    padding: 0px;\n    margin: 0px;\n    border-collapse: collapse;\n}\n\ntable th {\n    font-weight: 300;\n    padding-right: 3px;\n    margin: 0px;\n}\n\ntable td {\n    margin: 0px;\n    padding-left: 0px;\n    padding-top: 2px;\n    padding-bottom: 2px;\n    padding-right: 2px;\n}\n\ndiv.card {\n    background-color: #fefefe; /*var(--fourth-color);*/\n    /* border-radius: 5px; */\n    /* box-shadow: 0px 1px 2px #AEAEAE; */\n    margin: 5px;\n    padding-left: 5px;\n    padding-right: 5px;\n    padding-bottom: 5px;\n    padding-top: 0px;\n    gap: 0px;\n    text-align: left;\n}\n\np.cardTitle {\n    font-weight: 300;\n    text-align: left;\n    padding: 0px;\n    margin-top: 2px;\n}\n\n.popup {\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    background-color: #fff;\n    padding: 20px;\n    border: 1px solid #ccc;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    z-index: 1000;\n}\n\n.popupWrapper {\n    display: flex;\n    align-items: flex-end;\n}\n\n.pig {\n    margin-top: 10px;\n    display: flex;\n    flex-direction: row;\n    align-items: end;\n}\n\n/* todo solve either inheritance or composed class?*/\n.tab-active {\n    font-size: small;\n    /*padding: 10px 60px;*/\n    cursor: pointer;\n    opacity: 0.6;\n    background: white;\n    border: 0;\n    outline: 0;\n    border-bottom: 2px solid grey;\n    opacity: 1;\n}\n\n.tab-inactive {\n    font-size: small;\n    /*padding: 10px 60px;*/\n    cursor: pointer;\n    opacity: 0.6;\n    background: white;\n    border: 0;\n    outline: 0;\n}\n\n/* ------------------------------- */\n\na {\n    color: black;\n    text-decoration: none;\n}\n\na:hover {\n    color: darkorchid;\n    cursor: grab;\n}\n\nh1 {\n    color: var(--first-color);\n    font-size: x-large;\n    /* background-color: lightskyblue; */\n}\n\nh2 {\n    color: var(--first-color);\n    font-size: large;\n    padding-top: 20px;\n    padding-bottom: 0px;\n    margin-bottom: 0px;\n}\n\np {\n    text-align: justify;\n}\n\n/* ------------------------------- */\n\n.data-table td,\n.data-table th {\n    padding-left: 5px;\n    padding-right: 5px;\n    border-left: solid 1px lightgray;\n    border-right: solid 1px lightgray;\n}\n\n.data-table th {\n    font-size: small;\n    background-color: #f0f0f0;\n}\n\n.data-table {\n    border-collapse: collapse;\n    margin-top: 5px;\n    border: none;\n    /* border-bottom: solid 1px lightgray;\n    border-top: solid 1px lightgray; */\n    td:nth-child(1) {\n        text-align: center;\n        border-left: none;\n    }\n    td:nth-child(2) {\n        text-align: center;\n    }\n    td:nth-child(3) {\n        text-align: left;\n    }\n    td:nth-child(5) {\n        text-align: right;\n    }\n    td:nth-child(6) {\n        text-align: right;\n    }\n    td:last-child {\n        border-right: none;\n    }\n\n    th:nth-child(1) {\n        text-align: center;\n        border-left: none;\n    }\n    th:nth-child(2) {\n        text-align: center;\n    }\n    th:nth-child(3) {\n        text-align: left;\n    }\n    th:nth-child(5) {\n        text-align: right;\n    }\n    th:nth-child(6) {\n        text-align: right;\n    }\n    th:last-child {\n        border-right: none;\n    }\n\n    tr:nth-child(even) {\n        background-color: #f9f9e1;\n    }\n    width: 100%;\n}\n\n.example {\n    /* background-color: #eeffde; */\n    border: solid 1px lightgray;\n    border-radius: 4px;\n    padding: 5px;\n    padding-top: 0px;\n    margin: 0px;\n    margin-top: 15px;\n}\n\n.ex-label {\n    background-color: lightyellow;\n    margin-right: 5px;\n}\n\n.example > p {\n    margin-top: 3px;\n    /* padding-top: 2px; */\n}\n\n.example > p:last-child {\n    margin-bottom: 3px;\n}\n\n.c1 {\n    color: #2aafe4;\n}\n\n.c2 {\n    color: #49beb7;\n}\n\n.c3 {\n    color: #daa949;\n}\n\n.c4 {\n    color: #ee5959;\n}\n\n.c5 {\n    color: violet;\n}\n\n#data-types-shooting {\n    margin-top: 5px;\n    td:nth-child(1) {\n        text-align: left;\n    }\n    td:nth-child(2) {\n        text-align: right;\n    }\n    td:nth-child(3) {\n        text-align: left;\n    }\n}\n\np > ul {\n    margin-top: 5px;\n}\n\np > ul > li {\n    margin-top: 5px;\n}\n\n#table-binning-trees {\n    td:nth-child(1) {\n        text-align: center;\n    }\n    td:nth-child(2) {\n        text-align: left;\n    }\n    td:nth-child(3) {\n        text-align: right;\n    }\n    td:nth-child(4) {\n        text-align: right;\n    }\n\n    th:nth-child(1) {\n        text-align: center;\n    }\n    th:nth-child(2) {\n        text-align: left;\n    }\n    th:nth-child(3) {\n        text-align: right;\n    }\n    th:nth-child(4) {\n        text-align: right;\n    }\n}\n\n#table-comparison-histogram-bar-chart {\n    td:nth-child(1) {\n        text-align: left;\n        width: 50%;\n    }\n    td:nth-child(2) {\n        text-align: left;\n        width: 50%;\n    }\n\n    th:nth-child(1) {\n        text-align: left;\n        width: 50%;\n    }\n    th:nth-child(2) {\n        text-align: left;\n        width: 50%;\n    }\n}\n\n#version-footer {\n    bottom: 0;\n}\n\n.navigation-icon {\n    /* vertical-align: bottom; */\n    border: none;\n    background-color: transparent;\n    cursor: pointer;\n    color: #daa949;\n}\n\n.navigation-icon:hover {\n    color: coral;\n}\n\n.navigation-icon:active {\n    color: darkred;\n}\n\n.small-text {\n    margin-top: 3px;\n    font-size: 9pt;\n    margin-bottom: 3px;\n}\n\n.author-card {\n    display: flex;\n    flex-direction: row;\n    align-content: flex-start;\n    padding-top: 20px;\n    gap: 5px;\n}\n\n.author-heading {\n    font-size: large;\n    font-weight: 300;\n    color: #333333;\n    text-align: left;\n    margin: 0px;\n    padding: 0px;\n}\n\n.author-titles {\n    font-size: smaller;\n    color: grey;\n    padding: 0;\n    padding-bottom: 5px;\n    margin: 0;\n}\n\n.author-part-left {\n    display: flex;\n    flex-direction: column;\n    align-content: flex-start;\n    flex-basis: 180px;\n    flex-grow: 2;\n    min-width: 80px;\n    max-width: 200px;\n    padding-top: 0px;\n    margin-top: 0px;\n}\n\n.author-part-right {\n    flex-basis: 400px;\n    flex-grow: 4;\n    min-width: 200px;\n    padding-top: 2px;\n    padding-left: 5px;\n    margin-top: 0px;\n}\n\n.external-link {\n    color: #007bff;\n    text-decoration: none;\n}\n\n.external-link:hover {\n    text-decoration: underline;\n}\n\n.no-bullets {\n    list-style-type: none;\n}\n\n/* - SIMPLE VALUE TABLE ------------------------------ */\n\n.simple-table td,\n.simple-table th {\n    padding-left: 5px;\n    padding-right: 5px;\n    border-left: solid 1px lightgray;\n    border-right: solid 1px lightgray;\n    border-top: solid 1px lightgray;\n    border-bottom: solid 1px lightgray;\n    text-align: center; /* Optional: Centers the text inside cells */\n}\n\n.simple-table th {\n    font-size: small;\n    background-color: #f0f0f0;\n}\n\n.simple-table {\n    border-collapse: collapse;\n    table-layout: fixed; /* Ensures the table layout is fixed */\n    margin-top: 5px;\n    margin-bottom: 10px;\n    width: 100%;\n    border-left: solid 1px lightgray;\n    border-right: solid 1px lightgray;\n}\n\n.element-1 {\n    color: #0f9b8e;\n}\n.element-2 {\n    color: #138f8c;\n}\n.element-3 {\n    color: #17838a;\n}\n.element-4 {\n    color: #1b7788;\n}\n.element-5 {\n    color: #1f6b86;\n}\n.element-6 {\n    color: #236084;\n}\n.element-7 {\n    color: #275582;\n}\n.element-8 {\n    color: #2b4a80;\n}\n.element-9 {\n    color: #2f3f7e;\n}\n.element-10 {\n    color: #33347c;\n}\n\n.highlight-median {\n    background-color: #e0ffd0;\n}\n\n.highlight-quantile {\n    background-color: #fae5a9;\n}\n\n#table-interest-rates {\n    table-layout: auto;\n    td:nth-child(1) {\n        text-align: center;\n    }\n    td:nth-child(2) {\n        text-align: left;\n    }\n    width: auto;\n}\n\n#table-kinds-of-mean {\n    table-layout: auto;\n    td:nth-child(1) {\n        text-align: center;\n    }\n    td:nth-child(2) {\n        text-align: center;\n    }\n    td:nth-child(3) {\n        text-align: left;\n    }\n    td:nth-child(4) {\n        text-align: left;\n        max-width: 150px;\n    }\n    td:nth-child(5) {\n        text-align: center;\n    }\n}\n\n#variance-with-popmean {\n    table-layout: auto;\n    td:nth-child(1) {\n        text-align: center;\n    }\n    td:nth-child(2) {\n        text-align: center;\n    }\n    td:nth-child(3) {\n        text-align: center;\n    }\n    td:nth-child(4) {\n        text-align: center;\n    }\n    td:nth-child(5) {\n        text-align: center;\n    }\n}\n\n/* Sets A - tables */\n/* ------------------------------- */\n\n.data-table-powerset th {\n    background-color: grey;\n    color: white;\n}\n\n.data-table-powerset {\n    td:nth-child(1) {\n        text-align: center;\n        width: 40px;\n        border-left: none;\n    }\n    td:nth-child(2) {\n        text-align: center;\n        width: 40px;\n    }\n    td:nth-child(3) {\n        text-align: center;\n        width: 40px;\n    }\n    td:nth-child(4) {\n        text-align: left;\n    }\n    td:last-child {\n        border-right: none;\n    }\n\n    th:nth-child(1) {\n        text-align: center;\n        width: 40px;\n        border-left: none;\n    }\n    th:nth-child(2) {\n        text-align: center;\n        width: 40px;\n    }\n    th:nth-child(3) {\n        text-align: center;\n        width: 40px;\n    }\n    th:nth-child(4) {\n        text-align: left;\n    }\n    th:last-child {\n        border-right: none;\n    }\n}\n\n.simple-table-ops {\n    table-layout: auto;\n    td:nth-child(1) {\n        text-align: left;\n        width: 52px;\n    }\n    td:nth-child(2) {\n        text-align: center;\n    }\n    td:nth-child(3) {\n        text-align: left;\n    }\n    td:nth-child(4) {\n        text-align: center;\n    }\n    td:nth-child(5) {\n        text-align: right;\n        border-right: none;\n    }\n    td:nth-child(6) {\n        text-align: left;\n        border-left: none;\n    }\n    td:last-child {\n        border-right: none;\n    }\n\n    th:nth-child(5) {\n        text-align: left;\n        border-right: none;\n    }\n    th:nth-child(6) {\n        text-align: left;\n        border-left: none;\n    }\n}\n\nul.abc-list {\n    list-style-type: none;\n    padding: 10px;\n    margin: 0px;\n    padding-top: 0px;\n}\n\nul.abc-list li {\n    padding-top: 10px;\n    margin-left: 20px;\n    text-indent: -20px;\n}\n\nul.abc-list li::before {\n    content: attr(data-marker);\n    font-weight: normal;\n    margin-right: 10px;\n    /* display: inline-block; */\n}\n\n.simple-table-basic {\n    table-layout: auto;\n    td:nth-child(1) {\n        text-align: left;\n    }\n    td:nth-child(2) {\n        text-align: left;\n    }\n\n    th:nth-child(1) {\n        text-align: left;\n    }\n    th:nth-child(2) {\n        text-align: left;\n    }\n\n    td:last-child {\n        border-right: none;\n    }\n    th:last-child {\n        border-right: none;\n    }\n\n    td:first-child {\n        border-left: none;\n    }\n    th:first-child {\n        border-left: none;\n    }\n}\n\n.table-elementary-events {\n    td:nth-child(1) {\n        width: 40%;\n    }\n    th:nth-child(1) {\n        width: 40%;\n    }\n}\n\n.event-space-table-die {\n    th:nth-child(1) {\n        text-align: left;\n    }\n    th:nth-child(2) {\n        text-align: center;\n    }\n\n    th:nth-child(3) {\n        text-align: left;\n    }\n    th:nth-child(4) {\n        text-align: center;\n    }\n\n    th:nth-child(5) {\n        text-align: left;\n    }\n    th:nth-child(6) {\n        text-align: center;\n    }\n\n    th:nth-child(7) {\n        text-align: left;\n    }\n    th:nth-child(8) {\n        text-align: center;\n    }\n\n    td:nth-child(1) {\n        text-align: left;\n    }\n    td:nth-child(2) {\n        text-align: center;\n    }\n\n    td:nth-child(3) {\n        text-align: left;\n    }\n    td:nth-child(4) {\n        text-align: center;\n    }\n\n    td:nth-child(5) {\n        text-align: left;\n    }\n    td:nth-child(6) {\n        text-align: center;\n    }\n\n    td:nth-child(7) {\n        text-align: left;\n    }\n    td:nth-child(8) {\n        text-align: center;\n    }\n}\n\n.table-probability-overview tr:nth-child(2) td {\n    border-bottom: none;\n}\n.table-probability-overview tr:nth-child(3) td {\n    border-top: none;\n}\n\n.table-probability-overview th {\n    text-align: left;\n}\n\n.table-probability-overview td {\n    text-align: left;\n}\n\n/* --- TOC ---------------------------- */\n\n.page > span {\n    height: 100%;\n    width: 100%;\n}\n\n.chapter-container {\n    display: flex;\n    flex-direction: row;\n    /*align-items: center; */\n    /* width: 100%; */\n    box-sizing: border-box;\n    position: relative;\n    width: 100%;\n    height: 100%;\n}\n\n.toc {\n    position: absolute;\n    top: 0;\n    right: 0;\n    max-height: 100vh;\n    overflow-y: auto;\n    padding: 1rem;\n    background-color: #f0f0f0;\n    width: 150px;\n    text-align: left;\n}\n\n.toc ul {\n    list-style: none;\n    padding: 0;\n}\n\n.toc li {\n    margin: 0.5rem 0;\n    cursor: pointer;\n    color: #404040;\n}\n\n.toc li:hover {\n    /* text-decoration: underline; */\n    color: darkorchid;\n    /* cursor: grab; */\n}\n\ndiv.centered-content {\n    width: 710px;\n    max-width: 710px;\n    min-width: 710px;\n    height: 100%;\n    flex-grow: 0;\n    flex-shrink: 0;\n    position: absolute;\n    left: 50%;\n    transform: translateX(-50%);\n    padding: 0;\n    margin: 0;\n    overflow: scroll;\n}\n\n.table-dictionary {\n    td:nth-child(1) {\n        text-align: left;\n        width: 200px;\n    }\n    td:nth-child(2) {\n        text-align: left;\n        width: 200px;\n    }\n    td:nth-child(3) {\n        text-align: left;\n        width: 200px;\n    }\n\n    th:nth-child(1) {\n        text-align: left;\n    }\n    th:nth-child(2) {\n        text-align: left;\n    }\n    th:nth-child(3) {\n        text-align: left;\n    }\n}\n\n.simple-table-ed {\n    table-layout: auto;\n    text-align: center;\n    td:nth-child(1) {\n        text-align: left;\n    }\n    th:nth-child(1) {\n        text-align: left;\n    }\n}\n\n/*  */\n.histogram-table {\n    border-collapse: collapse;\n    margin-top: 5px;\n    border: none;\n    width: 100%;\n    /* border-bottom: solid 1px lightgray;\n    border-top: solid 1px lightgray; */\n}\n.histogram-table td:nth-child(1) {\n    text-align: center;\n    border-left: none;\n}\n\n.histogram-table td:nth-child(2),\n.histogram-table td:nth-child(3),\n.histogram-table td:nth-child(4),\n.histogram-table td:nth-child(5),\n.histogram-table td:nth-child(6) {\n    text-align: center;\n}\n\n.histogram-table td:last-child {\n    border-right: none;\n}\n\n.histogram-table th:nth-child(1) {\n    text-align: center;\n    border-left: none;\n}\n.histogram-table th:nth-child(2),\n.histogram-table th:nth-child(3),\n.histogram-table th:nth-child(4),\n.histogram-table th:nth-child(5),\n.histogram-table th:nth-child(6) {\n    text-align: center;\n}\n.histogram-table th:last-child {\n    border-right: none;\n}\n\n.histogram-table tr:nth-child(even) {\n    background-color: #f9f9e1;\n}\n\n.histogram-table tbody tr:last-of-type {\n    border-top: double 3px gainsboro;\n    border-bottom: solid 1px gainsboro;\n}\n\n.histogram-table-ex tbody td:nth-child(4) {\n    text-align: right;\n    padding-right: 22px;\n}\n\n.histogram-table-ex tbody tr:last-of-type {\n    border-top: none;\n    border-bottom: solid 1px gainsboro;\n}\n\n/* ol {\n    list-style-position: inside;\n    padding-left: 5px;\n} */\n\n.alpha-list {\n    list-style: none;\n    counter-reset: list-counter;\n    margin-left: 0px;\n    padding-left: 20px;\n}\n\n.alpha-list li {\n    counter-increment: list-counter;\n    /* display: flex; /* Ensures proper indentation */\n    align-items: flex-start;\n}\n\n.alpha-list li::before {\n    content: counter(list-counter, lower-alpha) \") \";\n    min-width: 2em; /* Ensures the label (a), b), etc.) has space */\n    flex-shrink: 0; /* Prevents it from shrinking */\n}\n\n.main-ex-list {\n    counter-reset: main-counter;\n    list-style: none;\n}\n\n.main-ex-list > li {\n    counter-increment: main-counter;\n    list-style-type: none;\n    margin-bottom: 8px;\n}\n\n.main-ex-list > li::before {\n    content: counter(main-counter) \". \";\n    font-weight: normal;\n}\n\n/* // probablitiy */\n\n.prob-theory {\n    display: flex;\n    flex-direction: row;\n    margin-bottom: 10px;\n}\n\n.prob-example {\n    display: flex;\n    flex-direction: row;\n    background-color: #eeeeee;\n    margin-bottom: 10px;\n}\n\n.prob-example div {\n    padding-left: 10px;\n    padding-right: 10px;\n}\n\n.prob-theory div {\n    padding-left: 10px;\n    padding-right: 10px;\n}\n\n.prob-example > div:not(:last-child) {\n    border-right: 1px solid lightgrey; /* Add light grey divider */\n}\n\n.prob-theory > div:not(:last-child) {\n    border-right: 1px solid lightgrey; /* Add light grey divider */\n}\n\n.table-interval-estimation {\n    table-layout: auto;\n    td:nth-child(2) {\n        text-align: left;\n    }\n    td:nth-child(3) {\n        text-align: left;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
